<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div class="container mt-4 mb-4">
    <div style="max-width:560px">
        <h3>Legg til bruker</h3>
        <br/>
        <div>
          <span class="ingredient-title">Fornavn</span>
          <input id="firstname" class="form-control" type="text" v-model="user.firstname"/>
        </div>

        <div>
          <span class="ingredient-title">Etternavn</span>
          <input id="lastname" class="form-control" type="text" v-model="user.lastname"/>
        </div>

        <div>
          <span class="ingredient-title">Rolle</span>
          <select class="form-select" v-model="user.userRole">
            <option value="">Velg rolle</option>
            <option value="EMPLOYEE">Ansatt</option>
            <!-- Read-only role: may view and download reports only -->
            <option value="ACCOUNTANT">Regnskapsfører</option>
            <!-- Only super admin can create merchant admin user -->
            <option v-if="isSuperAdmin()" value="ADMIN">Admin</option>
          </select>
        </div>

        <div>
          <span class="ingredient-title">Brukernavn</span>
          <input id="username" class="form-control" type="text" v-model="user.username"/>
        </div>

        <div>
          <span class="ingredient-title">Passord</span>
          <input id="userPassword" class="form-control" type="password" v-model="user.userPassword"/>
        </div>

        <div>
          <span class="ingredient-title">Gjenta passord</span>
          <input id="confirmPassword" class="form-control" type="password" v-model="confirmPassword"/>
        </div>
        <div v-if="user.userPassword !== confirmPassword">
          <span class="validation-failed">(Passordene er ikke like)</span>
        </div>

        <!-- Pinkode is only used for POS login; ACCOUNTANT is a backoffice read-only role and doesn't need it. -->
        <template v-if="user.userRole !== 'ACCOUNTANT'">
          <div>
            <span class="ingredient-title">Pinkode(4 sifre)</span>
            <input id="pincode" class="form-control" type="text" inputmode="numeric" maxlength="4" v-model="user.pincode" @input="checkUserPincode" />
          </div>
          <div v-if="!validPin" class="form-group">
            <span class="validation-failed">(Pin-koden er allerede i bruk)</span>
          </div>
        </template>

        <div>
          <span class="ingredient-title">Epost</span>
          <input id="email" class="form-control" type="text" v-model="user.email" @input="validateEmail" />
        </div>
        <div v-if="!validEmail">
          <span class="validation-failed">(Ugyldig epost)</span>
        </div>

        <div>
          <span class="ingredient-title">Telefon</span>
          <input id="phone" class="form-control" type="tel" inputmode="tel" v-model.trim="user.phone"/>
        </div>

        <div class="bo_hr mt-4">
          <hr/>
        </div>

        <div class="mb-5">
          <button v-if="activateSaveButton" type="button" class="bo_btn" @click="saveUser"> Lagre </button>
          <button v-else type="button" class="bo_btn" @click="saveUser" disabled="true"> Lagre </button>
        </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import MerchantUtil from "@/util/MerchantUtil";
import UserUtil from "@/util/UserUtil";
import UserService from "@/services/user/UserService";

export default {
  components: {LoadingSpinner},
  data() {
    return {
      loading: false,

      confirmPassword: "",
      validPin: true,
      validEmail: true,

      user: {
        type: "user",
        merchant: "",
        firstname: "",
        lastname: "",
        userRole: "",
        username: "",
        userPassword: "",
        pincode: "",
        email: "",
        phone: "",
        status: "ACTIVE"
      }
    };
  },
  mounted() {

  },
  computed: {
    activateSaveButton(){
      //console.log('user: ' + JSON.stringify(this.user));
      if(this.user.firstname.length > 0 && this.user.lastname.length > 0 && this.user.userRole.length > 0 && this.user.username.length > 0
          && this.user.userPassword.length > 0 && (this.user.userRole === 'ACCOUNTANT' || this.user.pincode.toString().length == 4) && this.user.email.length > 0 && this.user.phone.toString().length > 0
          && this.user.userPassword == this.confirmPassword && this.validEmail && this.validPin
      ){
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    isSuperAdmin(){
      return UserUtil.isSuperAdmin();
    },
    checkUserPincode(event){
      this.validPin = true; //reset it

      //The field is type="text" (a pincode is a digit STRING — type="number" bound it as a Number and
      //that number, written to the user document, breaks the login of the person being edited). So the
      //digits-only rule that type="number" used to give for free has to be enforced here.
      const digits = event.target.value.replace(/\D/g, '').slice(0, 4);
      if (digits !== event.target.value) {
        event.target.value = digits;
      }
      this.user.pincode = digits;

      console.log('pincode: ' + this.user.pincode);
      if(event.target.value.length == 4){
        //console.log('Check Pin');
        UserService.checkUserPincode(this.user.pincode).then(
            (response) => {
              let result = response.data;
              if(result === 'TRUE'){
                //result := true -> pincode exists
                //console.log(result + ": exists -> Ugyldig");
                this.validPin = false;
              } else {
                //result := false -> pincode doesn't exist
                //console.log(result + ": not exists -> Gyldig");
                this.validPin = true;
              }
              this.loading = false;
            },
            (error) => {
              console.log(error);
            }
        );
      }

    },
    validateEmail(){
        var re = /\S+@\S+\.\S+/;
        let validatedResult = re.test(this.user.email);
        console.log('validatedResult: ' + validatedResult);
        this.validEmail = validatedResult;
    },
    saveUser(){
      this.loading = true;

      this.user.merchant = MerchantUtil.getMerchant();
      if(this.user.userRole === 'ACCOUNTANT'){
        this.user.pincode = ''; //Accountant has no POS pincode; clear any stale value before saving.
      }
      this.createUser(this.user);
    },
    createUser(user){
      //console.log('user: ' + JSON.stringify(user));
      // Digit STRINGS, not numbers — the user document is read on every authenticated request and a
      // numeric phone makes that read throw, locking the user out. See UserEdit for the incident.
      user.phone = user.phone === null || user.phone === undefined ? '' : String(user.phone);
      user.pincode = user.pincode === null || user.pincode === undefined ? '' : String(user.pincode);

      UserService.createUser(user).then(
          (response) => {
            let documentId = response.data;
            if(documentId){
              this.$router.push({ path: 'users'});
            } else {
              console.log("Creating user failed");
            }
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    }
  }
};
</script>
